import React, { useContext } from 'react';
import * as Styled from './styled';
import { ThemeContext } from '@src/index';

const Loader = () => {
    const palette = useContext(ThemeContext);

    return (
        <Styled.LoaderWrapper>
            <Styled.EllipsesStage>
                <Styled.EllipseOne
                    $color={palette.BLOB_COLOR_1}
                />
                <Styled.EllipseTwo
                    $color={palette.BLOB_COLOR_2}
                />
                <Styled.EllipseThree
                    $color={palette.BLOB_COLOR_3}
                />
                <Styled.EllipseFour
                    $color={palette.BLOB_COLOR_1}
                />
                <Styled.EllipseFive
                    $color={palette.BLOB_COLOR_2}
                />
            </Styled.EllipsesStage>
        </Styled.LoaderWrapper>
    );
};

export default Loader;
